// extracted by mini-css-extract-plugin
export default {"titlePage_row":"TitlePageSection_titlePage_row__v0cGM"};